let enemyDefinitions = null;

export async function loadEnemyDefinitions() {
  if (enemyDefinitions) return enemyDefinitions;
  
  const response = await fetch('/data/enemies.json');
  const data = await response.json();
  enemyDefinitions = data.enemies;
  return enemyDefinitions;
}

export function calculateTargetDifficulty(distance) {
  if (distance === 0) return 0;
  if (distance === 1) return 0; // Basic spheres only at distance 1
  if (distance <= 3) return 1;
  return distance - 2;
}

export function generateMapEffect(distance) {
  if (distance <= 0) return null;
  
  // 10% at distance 1, scaling to 100% at distance 10
  const probability = Math.min(1, Math.max(0.1, distance / 10));
  
  if (Math.random() > probability) return null;
  
  // Randomly select 1, 2, or 3 turns of protection
  const protectionTurns = Math.floor(Math.random() * 3) + 1;
  return { type: 'absolute_protection', turns: protectionTurns };
}

export function weightedRandomSelect(candidates) {
  if (candidates.length === 0) return null;
  if (candidates.length === 1) return candidates[0];
  
  const totalWeight = candidates.reduce((sum, enemy) => sum + (enemy.rarity || 100), 0);
  let random = Math.random() * totalWeight;
  
  for (const enemy of candidates) {
    random -= (enemy.rarity || 100);
    if (random <= 0) {
      return enemy;
    }
  }
  
  return candidates[candidates.length - 1];
}

export async function selectEnemiesForDifficulty(targetDifficulty, options = {}) {
  const { distanceFromCenter = null } = options;
  
  // Special case: distance 1 always spawns exactly 1 basic sphere
  if (distanceFromCenter === 1) {
    const enemies = await loadEnemyDefinitions();
    const basicSphere = enemies.find(e => e.id === 'basic_sphere');
    if (basicSphere) {
      return [{
        id: basicSphere.id,
        difficulty: 0, // No stars for distance 1
        color: basicSphere.color,
        rarity: 'basic' // Special rarity for basic spheres
      }];
    }
  }
  
  if (targetDifficulty === 0) return [];
  
  const enemies = await loadEnemyDefinitions();
  const selected = [];
  let remainingDifficulty = targetDifficulty;
  
  // Filter out basic_sphere from normal enemy pool (only at distance 1)
  const availableEnemies = enemies.filter(e => e.id !== 'basic_sphere');
  
  while (remainingDifficulty > 0) {
    const candidates = availableEnemies.filter(e => e.difficulty <= remainingDifficulty);
    
    if (candidates.length === 0) {
      console.warn(`No enemies available for remaining difficulty ${remainingDifficulty}`);
      break;
    }
    
    const enemy = weightedRandomSelect(candidates);
    
    // Determine rarity based on difficulty
    let rarity = 'common';
    if (enemy.difficulty >= 4) rarity = 'rare';
    else if (enemy.difficulty >= 3) rarity = 'uncommon';
    
    selected.push({
      id: enemy.id,
      difficulty: enemy.difficulty,
      color: enemy.color,
      rarity: rarity
    });
    
    remainingDifficulty -= enemy.difficulty;
  }
  
  return selected;
}
